export const ru = {
    add_companion: 'Добавление попутчика',
    agreement: 'Нажимая кнопку «Сохранить», вы даёте своё',
    agreement_name: 'согласие на передачу персональных данных',
    contact_info: 'Контактная информация',
    contact_info_for: 'Нужна для связи в командировке и оформления такси',
    main_info: 'Основная информация',
    main_info_for: 'Нужна для оформления командировок',
};
